import { TemplatePage } from './types';

const live_streaming_frame_overlay: TemplatePage = {
  header: {
    color: '#FBF7F4',
    icon: 'images/video-templates/frame.jpg',
    title: 'Live Stream Frame Overlay Templates',
    title_meta: '20+ Free Live Stream Frame Overlay Templates ',
    description_meta:
      'Make impressive frame overlays for your live stream with Wave.video’s customizable templates. Give' +
      ' your show a highly professional look.',
    description:
      'Add frame overlays to your live stream if you broadcast by yourself or with up to four guests.' +
      ' Impress your viewers with custom and professional visual elements of your show.'
  },
  footer: {
    category: 'Live stream frame overlay templates',
    description:
      "Become a professional live streamer with Wave.video's collection of editable templates. You don't" +
      ' need a design background to make stylish and memorable overlays for your stream. Pick a pack of' +
      ' templates that fits your taste and easily create beautiful thumbnails, intros, technical screens,' +
      ' countdowns, lower thirds, and any other visual elements.'
  },
  content: [
    {
      type: 'templates',
      title: 'Live stream frame overlay templates',
      search: { name: 'LiveFrame', tags: 'LiveFrame' }
    },
    { type: 'calendar' }
  ]
};

export default live_streaming_frame_overlay;
